import { CButton, CCol, CRow } from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import adminAxiosInstance, { imageAxiosInstance } from "../../../config";
import galleryJpg from "../../assets/images/image-gallery.jpg";
import pdfIcon from "./../../assets/svg/pdf-icon.svg";
import { Form, Formik } from "formik";
import { Button } from "@coreui/coreui";

const CPKycEdit = () => {
  const navigate = useNavigate();
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);
  const adminToken = localStorage.getItem("token");

  //   const [kycImage?, setKycImage] = useState({
  //     aadhaarFrontImage: "",
  //     aadhaarBackImage: "",
  //     panCardImage: "",
  //     bankCheckImage: "",
  //     cmlUpload: "",
  //   });
  const [kycImage, setKycImage] = useState();
  let { id } = useParams();
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await adminAxiosInstance.get(`/cpManage/byId/${id}`,
      {
        headers: { Authorization: `Bearer ${adminToken}` },
      }
      );
      // console.log(response.data);
      setData(response.data.data);
      setKycImage(response?.data?.data?.kycDetails);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const uploadFile = async (e, type) => {
    let file = e.target.files[0];
    // setIsFileChanged(true);
    var formdata = new FormData();
    formdata.append("img", file);
    try {
      const response = await imageAxiosInstance.post("/upload", formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      // console.log(response.data.data);
      //   setImageData(response.data.data);
      setKycImage({
        ...kycImage,
        [type]: response?.data.data.mediaLink,
      });
    } catch (error) {
      // console.log(error);
    }
  };
  const handleSubmit = async (values) => {
    // console.log(values, kycImage);
    try {
      const response = await adminAxiosInstance.put(`/cpManage/update/${id}`, {
        kycDetails: { ...kycImage },
      },
      {
        headers: { Authorization: `Bearer ${adminToken}` },
      }
      );
      // console.log(response?.data);
      navigate("/admin/kyc/cpkyclist");
    } catch (error) {}
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <CCol>
        <CButton
          className="text-white mb-3"
          color="info"
          onClick={() => navigate(-1)}>
          Go Back
        </CButton>
      </CCol>
      <Formik
        initialValues={{
          aadhaarBackImage: kycImage?.aadhaarBackImage,
          aadhaarFrontImage: kycImage?.aadhaarFrontImage,
          panCardImage: kycImage?.panCardImage,
          bankCheckImage: kycImage?.bankCheckImage,
          cmlUpload: kycImage?.cmlUpload,
        }}
        onSubmit={handleSubmit}>
        {({ values }) => (
          <Form>
            <CRow>
              <CCol lg={4} md={6} sm={6} xs={12} className="mb-3">
                <div className="docImage">
                  <label htmlFor="FirstImg" className="fw-bold">
                    Aadhar Card Front Image
                  </label>
                  {kycImage?.aadhaarFrontImage &&
                  kycImage?.aadhaarFrontImage.indexOf(".pdf?generation=") ===
                    -1 ? (
                    <a href={kycImage?.aadhaarFrontImage}>
                      <img
                        id="FirstImg"
                        // src={
                        //   kycImage?.aadhaarFrontImage
                        //     ? kycImage?.aadhaarFrontImage
                        //     : galleryJpg
                        // }
                        src={
                          kycImage?.aadhaarFrontImage
                            ? kycImage?.aadhaarFrontImage
                            : galleryJpg
                        }
                        alt="docs"
                        className="img-fluid"
                      />
                    </a>
                  ) : (
                    <div>
                      <a href={kycImage?.aadhaarFrontImage}>
                        <img src={pdfIcon} />
                      </a>
                    </div>
                  )}
                  <label htmlFor="aadhaarFrontImage">
                    <input
                      type="file"
                      id="aadhaarFrontImage"
                      name="aadhaarFrontImage"
                      onChange={(e) => {
                        uploadFile(e, "aadhaarFrontImage");
                      }}
                      accept="image/*,.pdf"
                    />
                  </label>
                </div>
              </CCol>
              <CCol lg={4} md={6} sm={6} xs={12}>
                <div className="docImage">
                  <label htmlFor="FirstImg" className="fw-bold">
                    Aadhar Card Back Image
                  </label>
                  {kycImage?.aadhaarBackImage &&
                  kycImage?.aadhaarBackImage.indexOf(".pdf?generation=") ===
                    -1 ? (
                    <a href={kycImage?.aadhaarBackImage}>
                      <img
                        id="FirstImg"
                        src={
                          kycImage?.aadhaarBackImage
                            ? kycImage?.aadhaarBackImage
                            : galleryJpg
                        }
                        alt="docs"
                        className="img-fluid"
                      />
                    </a>
                  ) : (
                    <div>
                      <a href={kycImage?.aadhaarBackImage}>
                        <img src={pdfIcon} />
                      </a>
                    </div>
                  )}
                  <label htmlFor="aadhaarBackImage">
                    <input
                      type="file"
                      id="aadhaarBackImage"
                      name="aadhaarBackImage"
                      onChange={(e) => {
                        uploadFile(e, "aadhaarBackImage");
                      }}
                      accept="image/*,.pdf"
                    />
                  </label>
                </div>
              </CCol>
              <CCol lg={4} md={6} sm={6} xs={12}>
                <div className="docImage">
                  <label htmlFor="FirstImg" className="fw-bold">
                    Pan Card Image
                  </label>
                  {kycImage?.panCardImage &&
                  kycImage?.panCardImage.indexOf(".pdf?generation=") === -1 ? (
                    <a href={kycImage?.panCardImage}>
                      <img
                        id="FirstImg"
                        src={
                          kycImage?.panCardImage
                            ? kycImage?.panCardImage
                            : galleryJpg
                        }
                        alt="docs"
                        className="img-fluid"
                      />
                    </a>
                  ) : (
                    <div>
                      <a href={kycImage?.panCardImage}>
                        <img src={pdfIcon} />
                      </a>
                    </div>
                  )}
                  <label htmlFor="panCardImage">
                    <input
                      type="file"
                      id="panCardImage"
                      name="panCardImage"
                      onChange={(e) => {
                        uploadFile(e, "panCardImage");
                      }}
                      accept="image/*,.pdf"
                    />
                  </label>
                </div>
              </CCol>
              <CCol lg={4} md={6} sm={6} xs={12}>
                <div className="docImage">
                  <label htmlFor="FirstImg" className="fw-bold">
                    Bank Cheque Image
                  </label>
                  {kycImage?.bankCheckImage &&
                  kycImage?.bankCheckImage.indexOf(".pdf?generation=") ===
                    -1 ? (
                    <a href={kycImage?.bankCheckImage}>
                      <img
                        id="FirstImg"
                        src={
                          kycImage?.bankCheckImage
                            ? kycImage?.bankCheckImage
                            : galleryJpg
                        }
                        alt="docs"
                        className="img-fluid"
                      />
                    </a>
                  ) : (
                    <div>
                      <a href={kycImage?.bankCheckImage}>
                        <img src={pdfIcon} />
                      </a>
                    </div>
                  )}
                  <label htmlFor="bankCheckImage">
                    <input
                      type="file"
                      id="bankCheckImage"
                      name="bankCheckImage"
                      onChange={(e) => {
                        uploadFile(e, "bankCheckImage");
                      }}
                      accept="image/*,.pdf"
                    />
                  </label>
                </div>
              </CCol>
              <CCol lg={4} md={6} sm={6} xs={12}>
                <div className="docImage">
                  <label htmlFor="FirstImg" className="fw-bold">
                    CML File
                  </label>
                  {kycImage?.cmlUpload &&
                  kycImage?.cmlUpload.indexOf(".pdf?generation=") === -1 ? (
                    <a href={kycImage?.cmlUpload}>
                      <img
                        id="FirstImg"
                        src={
                          kycImage?.cmlUpload ? kycImage?.cmlUpload : galleryJpg
                        }
                        alt="docs"
                        className="img-fluid"
                      />
                    </a>
                  ) : (
                    <div>
                      <a href={kycImage?.cmlUpload}>
                        <img src={pdfIcon} />
                      </a>
                    </div>
                  )}
                  <label htmlFor="cmlUpload">
                    <input
                      type="file"
                      id="cmlUpload"
                      name="cmlUpload"
                      onChange={(e) => {
                        uploadFile(e, "cmlUpload");
                      }}
                      accept="image/*,.pdf"
                    />
                  </label>
                </div>
              </CCol>
              <CCol lg={4} md={6} sm={6} xs={12}>
                <CButton type="submit">Submit</CButton>
              </CCol>
            </CRow>
          </Form>
        )}
      </Formik>
    </>
  );
};

// export default KycEdit;

export default CPKycEdit;
